import { IGetEntregaObraByIdUseCase } from "../../../presentation/useCases/read/get_entrega_obra_by_id_use_case";
import { EntregaObraModel } from "../../models/entrega_obra_model";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetEntregaObraByIdUseCase
 */

export class GetEntregaObraByIdUseCase implements IGetEntregaObraByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObra: number): Promise<EntregaObraModel> {
    return await this.repository.getEntregaObraById(idEntregaObra);

  }

}
